module.exports = __webpack_public_path__ + "static/media/error-404.f5e96e13.jpg";